"use client";
import { useState, useEffect } from "react";
import { collection, getDocs } from "firebase/firestore";
import { db } from "@/lib/firebase";

export function usePortfolio() {
  const [data, setData] = useState({
    profile: null,
    projects: [],
    skills: [],
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        setError(null);

        // Fetch profile data
        const profileSnapshot = await getDocs(collection(db, "profile"));
        const profile = profileSnapshot.docs[0]?.data() || null;

        // Fetch projects
        const projectsSnapshot = await getDocs(collection(db, "projects"));
        const projects = projectsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        // Fetch skills
        const skillsSnapshot = await getDocs(collection(db, "skills"));
        const skills = skillsSnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));

        setData({
          profile,
          projects,
          skills,
        });
      } catch (err) {
        console.error("Error fetching portfolio data:", err);
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return { data, loading, error };
} 